import React from 'react';
import { BrowserRouter, Routes, Route, Router } from "react-router-dom";
import ReactDOM from 'react-dom/client';

import Layout from './pages/Layout';
import Home from './pages/Home';
import Room1 from './pages/Room1';
import CreateUser from './pages/CreateUser';
import ModerateUsers from './pages/ModerateUsers';
import NoPage from './pages/NoPage';


export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/room1" element={<Room1 />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/moderate" element={<ModerateUsers />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


